'use strict';

// function VideoResource(element, headingText, subheadingText, captionText, anchors) {
function VideoResource(element, anchors) {
	this.element = element;
	// this.headingText = headingText;
	// this.subheadingText = subheadingText;
	// this.captionText = captionText;
	this.anchors = anchors;
	/* this.heading =
		this.headingText
			? '<h3>' + this.headingText + '</h3>'
			: '';
	this.subheading =
		this.subheadingText
		? '<div class="subheading">' + this.subheadingText + '</div>'
				: '';
	this.caption =
		this.captionText
			? '<p>' + this.captionText + '</p>'
			: '';
	this.figcaption =
		this.heading.length || this.caption.length
			? '<figcaption>' + this.heading + this.subheading + this.caption + '</figcaption>'
			: '';
	this.markup = (
		'<figure class="mfp__popupFrame mfp--video">' +
			'<div class="mfp-close"></div>' +
			'<div class="mfp-iframe-scaler">' +
				'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
			'</div>' +
			this.figcaption +
		'</figure>'
	); */
	this.markup = (
		'<div class="mfp__popupFrame mfp--video">' +
			'<div class="mfp-close"></div>' +
			'<div class="mfp-iframe-scaler">' +
				'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
			'</div>' +
		'</div>'
	);
}

module.exports = VideoResource;
